import PropTypes from 'prop-types'
import React from 'react'
import { FilterForm } from '../FilterForm'
import { connect } from 'react-redux'
import { getPagination, getUserType } from '../../../selectors'
import config from 'SRC/config/config.yaml'

export class SellersFilter extends React.PureComponent {
  getTextsByUserType = userType => {
    return {
      searchText: config.userTypes.usersFilter[userType].searchText,
      countText: config.userTypes.usersFilter[userType].countText,
      description: config.userTypes.usersFilter[userType].description,
      placeholder: config.userTypes.usersFilter[userType].placeholder
    }
  }

  render () {
    const { userType } = this.props
    let texts
    console.log('text user type', userType)
    if (userType) {
      texts = this.getTextsByUserType(userType.seo)
    }
    return (texts ? <div className='pretraga-prodavnica'>
      <div className='pretraga-prodavnica-header clearfix'>
        <p className='heading'>{texts.searchText}</p>
        <p className='broj-prodavnica'>{texts.countText} <span>{this.props.usersCount}</span></p>
      </div>
      <div className='pretraga-prodavnica-content'>
        {texts.description.split(`<br />`).map((line, i) => <p key={i}>{line}</p>)}
        <FilterForm
          baseAs={`/${userType.seoPlu !== 'servisi-i-usluge' ? userType.seoPlu : 'servis-i-usluge'}`}
          placeholder={texts.placeholder}
        />
      </div>
    </div> : null
    )
  }
}

const mapStateToProps = state => {
  const pagination = getPagination(state)
  return {
    usersCount: pagination && pagination.totalCount ? pagination.totalCount : 0,
    userType: getUserType(state)
  }
}

SellersFilter.propTypes = {
  usersCount: PropTypes.number.isRequired,
  userType: PropTypes.shape({
    seo: PropTypes.string.isRequired,
    seoPlu: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    namePlu: PropTypes.string.isRequired
  })
}

SellersFilter.defaultProps = {
  usersCount: 0
}

export default connect(mapStateToProps)(SellersFilter)
